import IdentificationChecked from "@/components/configuration/profile/customer-terms/IdentificationChecked.vue";
import KycStatusApproved from "@/components/configuration/profile/customer-terms/KycStatusApproved.vue";
import CreditLimit from "@/components/configuration/profile/customer-terms/CreditLimit.vue";

const LOT_LIST_ITEM_TEMPLATE = `
  <div class="ta-lot-list-item-image-wrapper">
      <lot-list-item-image :lot="lot" />
      <lot-notify-start-button :lot="lot" />
  </div>
  <lot-winning-status :lot="lot" />
  <div class="ta-lot-list-item-content">
    <div class="ta-lot-list-item-desc">
      <div class="ta-lotno-bids-info d-flex justify-content-between">
        <lot-no :lot="lot" />
        <lot-number-of-bids :lot="lot" />
      </div>
      <lot-list-item-title :lot="lot" />
      <lot-collection-information :lot="lot" />
      <lot-current-price :lot="lot" />
      <lot-my-max-bid :lot="lot" />
      <lot-buy-now-price :lot="lot" />
    </div>
    <div class="ta-lot-list-item-buttons">
      <lot-add-to-watchlist :lot="lot" />
      <lot-countdown-timer :lot="lot" />
    </div>
  </div>
`;

const TEMPLATES = {
  components: {CreditLimit, KycStatusApproved, IdentificationChecked},
  lotListItemTemplate: LOT_LIST_ITEM_TEMPLATE,
  favoriteLotListItemTemplate: LOT_LIST_ITEM_TEMPLATE,
  iMadeBidLotListItemTemplate: LOT_LIST_ITEM_TEMPLATE,
  lotFiltersTemplate: `
    <!-- Number of items found based on the search criteria -->
    <lot-list-items-count />
    <!-- Auction Type Filtering -->
    <filter-auction-type />
    <!-- Lot filtering by status radio list -->
    <filter-lot-status />
    <!-- Winning/Losing radio button to filter lots by -->
    <filter-winning-or-losing/>
    <!-- Department List to filter lots based on -->
    <filter-department-list />
    <!-- Category list to filter lots based on. This component is only displayed if department is selected and categories are filtered by department -->
    <filter-category-list />
    <!-- State and municipality list to filter lots by -->
    <filter-location-list />
    <!-- Min/Max input fields to filter lots by price range -->
    <filter-price-range />
    <!-- Min/Max input fields to filter lots by reserve -->
    <filter-reserve-range />
    <!-- Min/Max input fields to filter lots by low/high estimate -->
    <filter-estimate-range />
    <!-- Min/Max input fields to filter lots by lot no range -->
    <filter-lot-range />
    <!-- Checkbox field to filter lots whether it has image or not -->
    <filter-with-image />
    <!-- The whole dynamic fields to filter lots -->
    <filter-dynamic-fields />
  `,
  lotListTemplate: `
    <lot-list-and-filters>
      <lot-list-filters />
      <div class="ta-lot-section">
        <div class="ta-lot-list-header-top">
          <lot-keyword-search />
          <jump-to-lot />
        </div>
        <div class="ta-lot-list-header ">
          <lot-list-per-page-select />
          <div class="ta-lot-search-wrapper">
            <sorting-dropdown/>
            <lot-list-switch-view/>
            <lot-list-filter-mobile-button/>
          </div>
        </div>
        <lot-list-items />
      </div>
    </lot-list-and-filters>
  `,
  departmentHomeTemplate: `
    <lot-list-and-filters>
      <div v-if="loading" class="ta-departments-loading">
          Loading...
      </div>
      <div v-else class="ta-lot-section">
        <div v-if="selectedDepartment" class="ta-department-info">
          <img v-if="selectedDepartment.image" :src="selectedDepartment.image" alt="">
  
          <h1 v-if="lotQueryParams.q" class="ta-department-lot-search">{{ $t('Your search result for "{keyword}"', {keyword: lotQueryParams.q}) }}</h1>
          <h1 v-else class="ta-department-title">{{ $options.filters.currentLocale(selectedDepartment.name) }}</h1>
          <lot-keyword-search />
        </div>
        <template v-if="!lotQueryParams.q">
            <FavouriteLotsShortList title="Watchlist"></FavouriteLotsShortList>
            <MyBidsShortList lot-status="published"></MyBidsShortList>
        </template>

        <template v-else>
          <div class="ta-lot-list-header ">
            <lot-list-per-page-select />
            <div class="ta-lot-search-wrapper">
              <sorting-dropdown/>
              <lot-list-switch-view/>
            </div>
          </div>
          <lot-list-items />
        </template>
      </div>
    </lot-list-and-filters>
  `,
  favoriteLotListTemplate: `
    <lot-list-and-filters>
      <div class="ta-lot-section">
        <div class="ta-lot-list-header-top">
          <lot-keyword-search />
        </div>
        <div class="ta-lot-list-header ">
          <lot-list-per-page-select />
          <div class="ta-lot-search-wrapper">
            <sorting-dropdown/>
            <lot-list-switch-view/>
          </div>
        </div>
        <favorite-lot-list-items />
      </div>
    </lot-list-and-filters>
  `,
  iMadeBidsLotListTemplate: `
    <lot-list-and-filters>
      <lot-list-filters />
      <div class="ta-lot-section">
        <div class="ta-lot-list-header-top">
          <lot-keyword-search />
        </div>
        <div class="ta-lot-list-header ">
          <lot-list-per-page-select />
          <div class="ta-lot-search-wrapper">
            <lot-list-auto-update-checkbox />
            <sorting-dropdown/>
            <lot-list-switch-view/>
            <lot-list-filter-mobile-button/>
          </div>
        </div>
        <i-made-bid-lot-list-items />
      </div>
    </lot-list-and-filters>
  `,
  lotViewTemplate: `
    <lot-view-header>
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="ta-lot-breadcrumbs">
            <lot-view-breadcrumbs />
            <jump-to-lot />
          </div>
        </div>
        <div class="col-md-4">
          <lot-view-prev-next-buttons />
        </div>
      </div>
    </lot-view-header>
    <auction-pause-message />
    <div class="row ta-lot-view-wrapper">
      <div class="col-lg-8 ta-lot-view-content">
        <div class="ta-lot-title-wrapper">
          <lot-view-title/>
          <lot-view-lot-no/>
        </div>
        <lot-view-images/>
        <lot-view-social-share/>
        <lot-view-description class="d-none d-lg-block" />
      </div>
      <div class="col-lg-4 ta-lot-view-bidding">
        <lot-view-bidding/>
      </div>
      <div class="col-lg-8 ta-lot-description-mobile d-block d-lg-none mt-3">
        <lot-view-description />
      </div>
    </div>
  `,
  lotBiddingTemplate: `
    <div class="ta-lot-bidding d-flex flex-column">
      <div class="ta-lot-bidding-timer d-flex align-items-center justify-content-between">
        <lot-countdown-timer :lot="lot"/>
        <watchlist-button :lot="lot"/>
      </div>
      <div class="ta-lot-bidding-content flex-grow-1">
        <lot-collection-information :lot="lot"/>
        <bidding-latest-notification/>
        <bidding-reserve-not-met/>
        <hr>
        <bidding-start-price/>
        <bidding-actions>
          <bidding-current-bid/>
          <bidding-input/>
          <bidding-max-bid/>
          <bidding-buy-now-button class="mt-4"/>
        </bidding-actions>
        <bidding-limit />
        <login-signup-buttons/>
        <hr>
        <private-treaty-actions/>
        <LatestBids/>
        <div v-if="mainConfig.descriptionInSidebar">
          <lot-view-description/>
        </div>
        <div v-if="mainConfig.sharesInSidebar">
          <hr>
          <SocialShareIcons :lot="lot"/>
        </div>
        <bidding-additional-links/>
      </div>
    </div>
  `,
  lotBiddingTemplateLive: `
    <div class="ta-lot-bidding d-flex flex-column">
      <div class="ta-lot-bidding-timer d-flex align-items-center justify-content-between">
        <lot-countdown-timer :lot="lot"/>
        <watchlist-button :lot="lot"/>
      </div>
      <div class="ta-lot-bidding-content flex-grow-1">
        <bidding-latest-notification/>
        <hr>
        <bidding-current-price/>
        <bidding-actions>
          <bidding-commission-bid-input />
          <bidding-buy-now-button class="mt-4"/>
          <hr>
          <stream-bid-button />
          <bidding-limit />
          <bidding-telephone-bid />
        </bidding-actions>
        <login-signup-buttons/>
        <div v-if="mainConfig.descriptionInSidebar">
          <hr>
          <lot-view-description/>
        </div>
        <div v-if="mainConfig.sharesInSidebar">
          <hr>
          <SocialShareIcons :lot="lot"/>
        </div>
        <bidding-additional-links/>
      </div>
    </div>
  `,
  homePageTemplate: `
    <home-departments />

    <lot-list-items />
  `,
  signupInputsTemplate: `
    <fieldset class="mb-4">
      <legend>{{ $t("Account Details") }}</legend>
      <div class="row">
        <email />
      </div>
      <div class="row">
        <password />
        <password-confirmation />
      </div>
    </fieldset>

    <fieldset class="mb-4">
      <legend>{{ $t("Profile information") }}</legend>

      <div class="row">
        <initials />
        <first-name />
        <middle-name />
        <last-name />
      </div>

      <div class="row">
        <gender />
        <title-input />
        <personal-id />
        <preferred-language/>
      </div>
      
      <div class="row">
        <company-name/>
        <phone />
      </div>
    </fieldset>

    <billing-address-details>
      <legend>{{ $t("Billing Address") }}</legend>
      
      <div class="row">
        <billing-address1 />
        <billing-address2 />
      </div>
      <div class="row">
        <billing-country />
        <billing-state />
      </div>
      <div class="row">
        <billing-city />
        <billing-zip-code />
      </div>
    </billing-address-details>

    <shipping-address-details :title="$t('Shipping Address')">
      
      <div class="row">
        <shipping-address1 />
        <shipping-address2 />
      </div>
      <div class="row">
        <shipping-country />
        <shipping-state />
      </div>
      <div class="row">
        <shipping-city />
        <shipping-zip-code />
      </div>
    </shipping-address-details> 

    <bank-account-details>
      <div class="d-flex justify-content-between align-items-center">
        <legend>{{ $t("Bank Account Details") }}</legend>
      </div>
      <div class="row">
        <bank-account-beneficiary />
        <bank-account-sort-code />
        <bank-account-number />
      </div>
      <div class="row">
        <bank-account-iban />
        <bank-account-swift />
        <bank-account-bank-name />
      </div>
      <div class="row">
        <bank-account-address1 />
        <bank-account-address2 />
        <bank-account-address3 />
      </div>
    </bank-account-details>
    
    <personal-identification-details >
      <div class="d-flex justify-content-between align-items-center">
        <legend>{{ $t("Personal Identification Details") }}</legend>
      </div>
      <div class="row">
        <identification-number />
        <identification-type />
      </div>
      <div class="row">
        <place-of-issue />
        <document-issue-date />
      </div>
      <div class="row">
        <document-expiration-date />
      </div>
    </personal-identification-details>
    
    <interest-checkboxes />
    
    <customer-terms>
        <div class="row">
            <vat-number />
        </div>
    </customer-terms>
    
    <div class="row">
        <subscribe-to-newsletter />
    </div>
    <div class="row">
        <terms-and-conditions />    
    </div>
  `,
  profileInputsTemplate: `
     <fieldset class="mb-4">
      <legend>{{ $t("Account Details") }}</legend>
      <div class="row">
        <email />
      </div>
      <div class="row">
        <old-password />
      </div>
      <div class="row">
        <password />
        <password-confirmation />
      </div>
    </fieldset>

    <fieldset class="mb-4">
      <legend>{{ $t("Profile information") }}</legend>

      <div class="row">
        <initials />
        <first-name />
        <middle-name />
        <last-name />
      </div>

      <div class="row">
        <gender />
        <title-input />
        <personal-id />
        <preferred-language/>
      </div>
      
      <div class="row">
        <company-name/>
        <phone />
      </div>
    </fieldset>

    <billing-address-details>
      <legend>{{ $t("Billing Address") }}</legend>
      
      <div class="row">
        <billing-address1 />
        <billing-address2 />
      </div>
      <div class="row">
        <billing-country />
        <billing-state />
      </div>
      <div class="row">
        <billing-city />
        <billing-zip-code />
      </div>
    </billing-address-details>

    <shipping-address-details :title="$t('Shipping Address')">
      
      <div class="row">
        <shipping-address1 />
        <shipping-address2 />
      </div>
      <div class="row">
        <shipping-country />
        <shipping-state />
      </div>
      <div class="row">
        <shipping-city />
        <shipping-zip-code />
      </div>
    </shipping-address-details> 

    <bank-account-details>
      <div class="d-flex justify-content-between align-items-center">
        <legend>{{ $t("Bank Account Details") }}</legend>
      </div>
      <div class="row">
        <bank-account-beneficiary />
        <bank-account-sort-code />
        <bank-account-number />
      </div>
      <div class="row">
        <bank-account-iban />
        <bank-account-swift />
        <bank-account-bank-name />
      </div>
      <div class="row">
        <bank-account-address1 />
        <bank-account-address2 />
        <bank-account-address3 />
      </div>
    </bank-account-details>
    
    <personal-identification-details >
      <div class="d-flex justify-content-between align-items-center">
        <legend>{{ $t("Personal Identification Details") }}</legend>
      </div>
      <div class="row">
        <identification-number />
        <identification-type />
      </div>
      <div class="row">
        <place-of-issue />
        <document-issue-date />
      </div>
      <div class="row">
        <document-expiration-date />
      </div>
    </personal-identification-details>
    
    <interest-checkboxes />
    
    <div class="row">
        <subscribe-to-newsletter />
    </div>
    <customer-terms>
        <div class="row">
            <vat-number />
            <credit-limit />
            <identification-checked/>
            <kyc-status-approved />
        </div>
    </customer-terms>
  `,
  auctionListItemTemplate: `
    <auction-pause-message :auction="auction" />
    <auction-image :auction="auction"/>
    <div class="ta-auction-list-item-desc">
      <div class="ta-auction-no-info d-flex justify-content-between">
        <auction-bidding-open :auction="auction"/>
        <auction-no :auction="auction"/>
        <number-of-lots :auction="auction"/>
      </div>
      <auction-title :auction="auction"/>
      <div class="ta-auction-list-item-dates">
        {{ auction.start_date | datetime }} <span v-if="auction.end_date"> - {{ auction.end_date | datetime }}</span>
      </div>
      <auction-location-information :auction="auction"/>
    </div>
    <div class="ta-auction-list-item-buttons">
      <auction-type :auction="auction" />
      <auction-countdown-timer :auction="auction" />
    </div>
  `,
  favoriteAuctionListItemTemplate: `
    <auction-image :auction="auction"/>
    <div class="ta-auction-list-item-desc">
      <div class="ta-auction-no-info d-flex justify-content-between">
        <auction-no :auction="auction"/>
        <number-of-lots :auction="auction"/>
      </div>
      <auction-title :auction="auction"/>
      <div class="ta-auction-list-item-dates">
        {{ auction.start_date | datetime }} <span v-if="auction.end_date"> - {{ auction.end_date | datetime }}</span>
      </div>
    </div>
    <div class="ta-auction-list-item-buttons">
      <auction-add-to-watchlist :auction="auction"/>
      <auction-countdown-timer :auction="auction" />
    </div>
  `,
  favoriteAuctionListPageTemplate: `
    <div class="ta-auction-section">
      <div class="ta-auction-list-header-top">
        <auction-keyword-search />
      </div>
      <hr class="mt-0">
      <div class="ta-auction-list-header ">
        <per-page-select />
        <div class="ta-auction-search-wrapper mb-3">
          <sorting-dropdown/>
          <switch-view/>
        </div>
      </div>
      <favorite-auction-list-items />
      <div class="ta-auction-list-footer">
        <pagination-summary/>
        <pagination-buttons/>
      </div>
    </div>
  `,
  auctionListPageTemplate: `
    <auction-list-filters />
    <div class="ta-auction-section">
      <div class="ta-auction-list-header-top">
        <auction-keyword-search />
      </div>
      <hr class="mt-0">
      <div class="ta-auction-list-header ">
        <per-page-select />
        <div class="ta-auction-search-wrapper mb-3">
          <sorting-dropdown/>
          <switch-view/>
        </div>
      </div>
      <auction-list-items />
      <div class="ta-auction-list-footer">
        <pagination-summary/>
        <pagination-buttons/>
      </div>
    </div>
  `,
  auctionFiltersTemplate: `
    <filter-auction-status />
    <filter-department-list />
    <filter-auction-date />
  `,
  auctionViewPageTemplate: `
    <breadcrumbs />
    <auction-info/>
    <bidding-telephone-bid />
    <auction-pause-message />
    <auction-sessions />
    <lot-list-and-filters>
        <lot-list-filters/>
        <div class="ta-lot-section">
            <div class="ta-lot-list-header-top">
                <lot-keyword-search/>
                <jump-to-lot/>
            </div>
            <div class="ta-lot-list-header ">
                <lot-list-per-page-select/>
                <div class="ta-lot-search-wrapper">
                    <sorting-dropdown/>
                    <lot-list-switch-view/>
                    <lot-list-filter-mobile-button/>
                </div>
            </div>
            <lot-list-items/>
        </div>
    </lot-list-and-filters>
  `,
  placeBidModalTemplate: `
    <ModalLotDetails :lot="lot"/>

    <div class="ta-lot-bidding lot-bidding-layout-grid">
      <lot-view-lot-no :label="$t('Lot Number')"/>
      <lot-countdown-timer :lot="lot"/>
      <bidding-start-price/>
      <div class="mb-2">
        <label class="muted-label">{{ $t('Current Bid') }}</label>
        <LotActualPrice :lot="lot"/>
      </div>
      <div class="mb-2">
        <label class="muted-label">{{ $t('Buy now') }}</label>
        <div class="text-black-600">{{ lot.buy_now_price || '(Empty)' }}</div>
      </div>
      <div class="mb-2">
        <label class="muted-label">{{ $t('No of bids') }}</label>
        <LotNumberOfBids :lot="lot"/>
      </div>
    </div>

    <bidding-actions>
      <div class="ta-lot-bidding-max-bid-wrapper">
        <bidding-input :label="true" class="mb-3" :for-mobile="true"/>
      </div>
      <bidding-max-bid-input/>
      <bidding-buy-now-button :for-mobile="true" class="mt-4"/>
    </bidding-actions>
  `,
  bankAccountDetailsTemplate: `
    <div class="d-flex justify-content-between align-items-center">
      <legend>{{ $t("Bank Account Details") }}</legend>
    </div>
    <div class="row">
      <identification-number />
      <identification-type />
      <place-of-issue />
      <document-issue-date />
      <document-expiration-date />
    </div>
  `,
  sellAnItemModalTemplate: `
    <div class="row">
      <div class="col-6">
        <DepartmentInput />
      </div>
      <div class="col-6">
        <CategoryInput />
      </div>
      <div class="col-6">
        <QuantityInput />
      </div>
      <div class="col-6">
        <ReserveInput />
      </div>
    </div>
    <ImageInput />
    <DynamicFieldInputs />
  `,
  auctionDetailsTemplate: `
    <div class="ta-auction-info mb-3">
      <AuctionCover />
      <div class="d-flex">
        {{ $t('Auction') }} | <AuctionNo /> - <AuctionActiveDate  :datetime="false"/>
      </div>
      <div class="row">
        <div class="col-md-8 col-lg-9">
          <AuctionTitle />
          <AuctionDescription />
          <AuctionNumberOfLots />
          <AuctionViewingInfo />
          <AuctionViewingDates />
          <AuctionPrivateViewingDates />
          <AuctionStartDate />
          <AuctionEndDate />
          <AuctionDates />
          <AuctionCurrency />
          <div class="d-flex mb-3">
            <AuctionViewType />
            <AuctionLocation />
          </div>
  
          <AuctionRegisterAsBidder />
          <AuctionStreamBid />
          <LoginSignupButtons/>
        </div>
        <div class="col-md-4 col-lg-3">
          <AuctionCountDown />
          <AuctionCatalogLink />
          <AuctionTermsLink />
          <AuctionIncrementsLink />
          <AuctionBuyersPremiumLink />
          <AuctionContactDetails />
        </div>
      </div>
    </div>
  `,
  bidConfirmationTemplate: `
    <confirmation-message />
    <lot-details :lot="lot"/>
    <tax-rate-and-premiums :lot="lot"/>
    <bid-amounts :lot="lot" :bid-amount="bidAmount"/>
  `,
  buyNowConfirmationTemplate: `
    <confirmation-message />
    <lot-details :lot="lot"/>
    <tax-rate-and-premiums :lot="lot"/>
    <bid-amounts :lot="lot" :bid-amount="bidAmount"/>
  `,
  maxBidModalTemplate: `
    <tax-rate-and-premiums :lot="lot"/>
    <bid-amounts :lot="lot" :bid-amount="bidAmount"/>
  `,
  bidCreatedModalTemplate: `
    <bid-placed-message />
    <your-bid />
    <bid-increment />
    <bid-date />
  `,
  maxBidCreatedModalTemplate: `
    <bid-placed-message />
    <your-max-bid />
    <bid-increment />
    <bid-date />
  `,
  lotPurchasedModalTemplate: `
    <bid-placed-message />
    <your-bid />
    <bid-date />
  `,
  errorPageTemplate: `
    <h2>{{error.code}}, {{error.message}}</h2>
  `
}

export default TEMPLATES
